import { render, staticRenderFns } from "./InventoryContent.vue?vue&type=template&id=97d66806&"
import script from "./InventoryContent.vue?vue&type=script&lang=js&"
export * from "./InventoryContent.vue?vue&type=script&lang=js&"
import style0 from "./InventoryContent.vue?vue&type=style&index=0&id=97d66806&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports